import React from "react";
import {useSelector} from "react-redux";
import {TabPanel, TabView} from "primereact/tabview";
import {CONTENT_TYPE_UIDS} from "../../../system/content-type-registry";
import {hasAdminPermission} from "../../../system/admin-access";
import {useTranslate} from "../../../system/useTranslate";
import BillingCollectionTable, {dateColumn, moneyColumn, relationColumn, statusColumn} from "../components/billing-collection-table";

export default function PurchasesDomainTab() {
    const translate = useTranslate();
    const {user} = useSelector((state) => state.auth);
    const canViewOrders = hasAdminPermission(user, "orders.view");
    const canViewInvoices = hasAdminPermission(user, "invoices.view");
    const canViewPayments = hasAdminPermission(user, "payments.view");
    const canViewRefunds = hasAdminPermission(user, "refunds.request") || hasAdminPermission(user, "refunds.approve");
    return (
        <TabView className="rtl text-xs">
            {canViewOrders && <TabPanel header={translate("billing-admin-orders")}>
                <BillingCollectionTable uid={CONTENT_TYPE_UIDS.ORDER} titleKey="billing-admin-orders" columns={[
                    {field: "orderNumber", headerKey: "sales-order-number"},
                    relationColumn("workspace", "sales-workspace"),
                    moneyColumn("totalAmount"),
                    statusColumn("orderStatus"),
                    dateColumn("createdAt"),
                ]}/>
            </TabPanel>}
            {canViewOrders && <TabPanel header={translate("billing-admin-order-items")}>
                <BillingCollectionTable uid={CONTENT_TYPE_UIDS.ORDER_ITEM} titleKey="billing-admin-order-items" columns={[
                    relationColumn("order", "billing-admin-order"),
                    {field: "title", headerKey: "name"},
                    {field: "quantity", headerKey: "billing-admin-quantity"},
                    moneyColumn("total"),
                    {field: "itemType", headerKey: "billing-admin-item-type"},
                ]}/>
            </TabPanel>}
            {canViewInvoices && <TabPanel header={translate("billing-admin-invoices")}>
                <BillingCollectionTable uid={CONTENT_TYPE_UIDS.INVOICE} titleKey="billing-admin-invoices" columns={[
                    {field: "invoiceNumber", headerKey: "billing-admin-number"},
                    relationColumn("workspace", "sales-workspace"),
                    moneyColumn("totalAmount"),
                    statusColumn("invoiceStatus"),
                    dateColumn("issuedAt"),
                ]}/>
            </TabPanel>}
            {canViewPayments && <TabPanel header={translate("billing-admin-payments")}>
                <BillingCollectionTable uid={CONTENT_TYPE_UIDS.PAYMENT} titleKey="billing-admin-payments" columns={[
                    {field: "paymentNumber", headerKey: "billing-admin-number"},
                    relationColumn("workspace", "sales-workspace"),
                    moneyColumn("amount"),
                    statusColumn("paymentStatus"),
                    dateColumn("createdAt"),
                ]}/>
            </TabPanel>}
            {canViewRefunds && <TabPanel header={translate("billing-admin-refunds")}>
                <BillingCollectionTable uid={CONTENT_TYPE_UIDS.REFUND} titleKey="billing-admin-refunds" columns={[
                    {field: "refundNumber", headerKey: "billing-admin-number"},
                    relationColumn("payment", "billing-admin-payment"),
                    moneyColumn("amount"),
                    statusColumn("refundStatus"),
                    dateColumn("requestedAt"),
                ]}/>
            </TabPanel>}
        </TabView>
    );
}
